
import { defineComponent, reactive, PropType, onMounted } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

import { TakeOrder, ChangeOrderTakeDatePayload } from '@/new-services/types/takes'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { DataState } from '@/core/classes/DataState.class'
import { PeriodT } from '@/core/types/companies.types'
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: {
        NewModal,
        TheInput,
        TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Object as PropType<TakeOrder>,
            required: true,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            take_date: null as string | null,
            periodId: null as number | null,
        })

        const data_state = reactive({
            periods: new DataState<PeriodT>({}),
        })

        const validation$ = useVuelidate(
            {
                take_date: { required },
            },
            state
        )

        const onSubmit = () => {
            if (props.loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            const payload: ChangeOrderTakeDatePayload = {
                orderId: props.order.orderId,
                newDate: state.take_date as string,
                periodId: state.periodId as number,
            }

            emit('submit', payload)
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const loadPeriods = async () => {
            data_state.periods.pagination.current_page = 1

            try {
                data_state.periods.is_loading = true
                const response = await orders.getPeriods()
                data_state.periods.list = response.data

                data_state.periods.pagination.total_pages = 1

                data_state.periods.is_failed = false
                data_state.periods.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.periods.failure.catchError(error)

                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_failed = true
                }
            } finally {
                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_loading = false
                }
            }
        }

        onMounted(loadPeriods)

        return {
            data_state,
            state,
            validation$,
            onSubmit,
            onCancel,
            loadPeriods,
        }
    },
})
